import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";

//import Alert
import { toast } from "react-toastify";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

// import TimeregService from "../../services/timereg.service";
import RegsugarService from "../../services/regsugar.service";
import academyService from "../../services/academy.service";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "./Modaladdsugarcane.css";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

// import config from "../../config";
import ModaladdFarmer from "../Farmer/ModaladdFarmer";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function Modaladdsugarcane(props) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [check, setCheck] = useState([]);
  const [showAddfarmer, setShowAddfarmer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabledbutton, setDisabledbutton] = useState(true);
  const [assoc, setAssoc] = useState([]);

  const getMember = (farmer_idcard) => {
    academyService.getAcademyByPersonId(farmer_idcard).then((res) => {
      if (res.data.success && res.data.data.length > 0) {
        setAssoc(res.data.data);
      }
    });
  };

  const checkID = (id) => {
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  };

  const handleClose = () => {
    initialForm();
    props.hidden(false);
    setCheck([]);
    setAssoc([]);
  };

  const initialForm = () => {
    setForm({});
    setErrors({});
  };
  const setField = (field, value) => {
    setCheck([]);
    setDisabledbutton(true);
    if (field.name == "search") {
      if (value.length < 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขไม่ครบ" });
      } else if (value.length > 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขเกิน" });
      } else if (!checkID(value)) {
        setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
      } else {
        setErrors({ ...errors, [field.name]: null });
      }
    }
    setForm({
      ...form,
      [field.name]: value,
    });
    if (errors[field.name] && field.name != "search") {
      if (errors[field.name])
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };
  const findFormErrors = () => {
    const { search } = form;
    const newErrors = {};

    // start date errors
    if (!search || search === "") newErrors.search = "กรุณากรอกคำค้นหา";
    // else if (usertype.length > 2) newErrors.usertype = "name is too long!";

    // // end date errors
    // if (!end_date || end_date === "")
    //   newErrors.end_date = "กรุณากรอกวันสิ้นสุด";

    return newErrors;
  };

  const handleAddFarmer = (object) => {
    const search = { search: object[0].farmer_idcard };
    setForm(search);
    RegsugarService.checkFarmer(search)
      .then((response) => {
        if (response.data.success) {
          checkStatusForReg(response.data.data);
          setCheck(response.data.data);
        }
      })
      .catch((error) => {
        toast.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCheck = (e) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
    } else {
      getMember(form.search);
      RegsugarService.checkFarmer(form)
        .then((response) => {
          if (response.data.success) {
            checkStatusForReg(response.data.data);
            if (response.data.data.length != 0) {
              setCheck(response.data.data);
            } else {
              confirmAlert({
                title: "",
                message: "ไม่มีข้อมูลเกษตรกรในระบบต้องการเพิ่มข้อมูลใช่หรือไม่",
                buttons: [
                  {
                    label: "ใช่",
                    onClick: () => {
                      // window.location.href = config.hostname + "/staff/farmer";
                      setShowAddfarmer(true);
                      // props.hidden(false);
                    },
                  },
                  {
                    label: "ไม่ใช่",
                    onClick: () => false,
                  },
                ],
                overlayClassName: "confirm-alert-default",
              });
            }
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // const handleSubmit = (e) => {
  //   // console.log(form);
  //   // const data = new FormData();
  //   // for (const key in form) {
  //   //   data.append(key, form[key]);
  //   // }
  //   e.preventDefault();
  //   const newErrors = findFormErrors();
  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //   } else {
  //     //   console.log("submit");
  //     const user = JSON.parse(sessionStorage.getItem("user"));
  //     TimeregService.checkFarmer(user.user.user_id, form)
  //       .then((response) => {
  //         if (response.data.success) {
  //           props.setdata([response.data.data, ...props.data]);
  //           initialForm();
  //           props.hidden(false);
  //         } else {
  //           alert(response.data.message);
  //         }
  //       })
  //       .catch((error) => {
  //         alert(error);
  //         console.log(error);
  //       })
  //       .finally(() => {
  //         console.log(false);
  //       });
  //   }
  // };

  const clickRegsugarcane = (farmer_idcard) => {
    props.selectFarmerIdcard(farmer_idcard);
    props.setShowAddDetail(true);
    props.hidden(false);
    props.setFarmerid(check.length != 0 ? check[0].farmer_id : 0);
    setCheck([]);
  };

  const checkStatusForReg = (data) => {
    if (data.length != 0) {
      const result = data.filter((a) => {
        if (a.status === "เสียชีวิต" || a.status === "ชาวไร่") {
          return true;
        } else if (
          (a.approve_status === "ฉบับร่าง" ||
            a.approve_status === "รออนุมัติ" ||
            a.approve_status === "ขอเอกสาร") &&
          a.timereg_id == props.timereg_id
        ) {
          return true;
        } else {
          return false;
        }
      });
      setDisabledbutton(result.length > 0 ? true : false);
    } else {
      setDisabledbutton(true);
    }
  };

  const statusFormatter = (cell, row) => {
    if (row.status == "ชาวไร่") {
      return <p className="text-success">{row.status}</p>;
    } else if (row.status == "เสียชีวิต") {
      return <p className="text-danger">{row.status}</p>;
    } else {
      return <p>{row.status}</p>;
    }
  };

  // const actionsEdittFormatter = (cell, row) => {
  //   return (
  //     <button
  //       disabled={
  //         row.status == "เป็น" || row.approve_status == "รออนุมัติ"
  //           ? true
  //           : false
  //       }
  //       className="btn btn-primary btn-sm"
  //       onClick={() => clickRegsugarcane(row.farmer_idcard)}
  //     >
  //       จดทะเบียน
  //     </button>
  //   );
  // };

  const columns = [
    {
      dataField: "timereg_id",
      text: "timereg_id",
      hidden: true,
    },
    // {
    //   dataField: "farmer_idcard",
    //   text: "หมายเลข 13 หลัก",
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "50px" };
    //   },
    //   style: {
    //     wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
    {
      dataField: "farmer_name",
      text: "ชื่อ",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_lastname",
      text: "นามสกุล",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "status",
      text: "สถานะ",
      formatter: statusFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "timereg_desc",
      text: "รอบจดทะเบียน",
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "approve_status",
      text: "ผลการพิจารณา",
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_card_id",
      text: "เลขชาวไร่",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "start_date",
      text: "เริ่ม",
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "end_date",
      text: "สิ้นสุด",
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    // {
    //   text: "จดทะเบียน",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsEdittFormatter,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "40px" };
    //   },
    //   style: {
    //     wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
  ];

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <ModaladdFarmer
        show={showAddfarmer}
        hidden={(a) => setShowAddfarmer(a)}
        setdata={(a) => handleAddFarmer(a)}
      />
      <Modal size="xl" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>จดทะเบียนชาวไร่อ้อย</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="search-check">
            <Form>
              <Row className="search-check">
                <Col lg="5">
                  <Form.Group>
                    <FormControl
                      placeholder="กรอกเลขบัตรประชาชน"
                      type="number"
                      name="search"
                      value={form.search}
                      onChange={(e) => setField(e.target, e.target.value)}
                      isInvalid={!!errors.search}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.search}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg="5">
                  <Form.Group>
                    <button
                      className="btn btn-primary btn-add-custom"
                      onClick={handleCheck}
                    >
                      ค้นหาและตรวจสอบ
                    </button>
                  </Form.Group>
                </Col>
                <Col lg="2">
                  <Form.Group>
                    <button
                      disabled={disabledbutton}
                      className="btn btn-success btn-disable-custom"
                      onClick={() => clickRegsugarcane(form.search)}
                    >
                      จดทะเบียน
                    </button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="list-regsugar-name">
            <BootstrapTable
              keyField="timereg_id"
              data={check}
              columns={columns}
            />
          </div>
          {assoc.map((item, key) => {
            return (
              <div key={key}>
                <li className="cademy-ui" key={key} name={item.association_id}>
                  {item.association_name_th}
                </li>
              </div>
            );
          })}
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-warning" onClick={handleClose}>
            Close
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            Save Changes
          </button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Modaladdsugarcane;

Modaladdsugarcane.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
  setShowAddDetail: PropTypes.func,
  selectFarmerIdcard: PropTypes.func,
  setFarmerid: PropTypes.func,
  timereg_id: PropTypes.number,
};
